export default __webpack_public_path__ + "static/media/postermodalimg.fd7ba486.jpg";